import React from 'react';
import { Empty, Table } from 'antd';

export interface KeyValueRow {
  key: React.Key;
  label: React.ReactNode;
  value: any;
}

interface Props {
  rows: KeyValueRow[];
  pageSize?: number;
  labelWidth?: number;
  valueRender?: (value: any, row: KeyValueRow) => React.ReactNode;
}

const KeyValuePagedTable: React.FC<Props> = ({ rows, pageSize = 8, labelWidth = 420, valueRender }) => {
  return (
    <Table
      dataSource={rows}
      columns={[
        { title: '关键指标', dataIndex: 'label', key: 'label', width: labelWidth, onHeaderCell: () => ({ style: { fontWeight: 400 } }) },
        {
          title: '详情',
          dataIndex: 'value',
          key: 'value',
          render: (val: any, row: any) => (valueRender ? valueRender(val, row) : val),
        },
      ]}
      pagination={{ pageSize, showSizeChanger: false }}
      bordered
      rowKey="key"
      size="small"
      locale={{ emptyText: <Empty description="暂无数据" image={Empty.PRESENTED_IMAGE_SIMPLE} /> }}
    />
  );
};

export default KeyValuePagedTable;

